import apiClient from "@/app/api/client";
import type { CreatePositionInput, Position, UpdatePositionInput } from "../types";

interface PositionListResponse {
	success: true;
	data: Position[];
}

interface SinglePositionResponse {
	success: true;
	data: Position;
}

export const positionsService = {
	async list(): Promise<Position[]> {
		const response = await apiClient.get<PositionListResponse>("/positions");
		return response.data.data;
	},

	async create(input: CreatePositionInput): Promise<Position> {
		const response = await apiClient.post<SinglePositionResponse>("/positions", input);
		return response.data.data;
	},

	async update(id: string, input: UpdatePositionInput): Promise<Position> {
		const response = await apiClient.patch<SinglePositionResponse>(`/positions/${id}`, input);
		return response.data.data;
	},

	async remove(id: string): Promise<void> {
		await apiClient.delete(`/positions/${id}`);
	},
};
